<div class="mc-side">

  <h4>Mi cuenta</h4>

  <div class="mc-nav">
    <a *ngFor="let item of items"
       [routerLink]="[item.ruta]"
       routerLinkActive="on"
       [routerLinkActiveOptions]="{ exact: true }"
       (click)="navegar.emit()">
      <span class="mc-ico"></span>
      {{ item.texto }}
      <span class="mc-pendiente" *ngIf="item.pendiente" title="Pantalla pendiente">·</span>
    </a>
  </div>

  <button type="button" class="mc-salir" (click)="cerrarSesion.emit()">
    Cerrar sesión
  </button>

  <!-- Oculto por ahora: no hay fecha de alta del socio en ninguna API (era dato
       de ejemplo). Cuando exista, se reactiva con texto neutro (sin asumir
       genero, como hacia "socia"):
  <div class="mc-sidefoot">
    Sos parte del Club desde <b>{{ socioDesde }}</b>
  </div>
  -->

</div>
